/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetRecurringTemplateQueryResponse, GetRecurringTemplatePathParams, GetRecurringTemplate400, GetRecurringTemplate401, GetRecurringTemplate403, GetRecurringTemplate404, GetRecurringTemplate409, GetRecurringTemplate500 } from "../../types/financialHubController/GetRecurringTemplate.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetRecurringTemplateUrl(organizationId: GetRecurringTemplatePathParams["organizationId"], templateId: GetRecurringTemplatePathParams["templateId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/financial/recurring/templates/${templateId}` as const }
  return res
}

/**
 * @summary Get a recurring template
 * {@link /api/organizations/:organizationId/financial/recurring/templates/:templateId}
 */
export async function getRecurringTemplate(organizationId: GetRecurringTemplatePathParams["organizationId"], templateId: GetRecurringTemplatePathParams["templateId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetRecurringTemplateQueryResponse, ResponseErrorConfig<GetRecurringTemplate400 | GetRecurringTemplate401 | GetRecurringTemplate403 | GetRecurringTemplate404 | GetRecurringTemplate409 | GetRecurringTemplate500>, unknown>({ method : "GET", url : getGetRecurringTemplateUrl(organizationId, templateId).url.toString(), ... requestConfig })
  return res.data
}